import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@components/atoms/button';
import { Typography } from '@components/atoms/typography';
import { Checkbox } from '@components/moleculs/checkbox';
import Stack from '@mui/material/Stack';

import { ConsentBlock } from '../consent-block';
import type { StartConsent } from '../consent-block/use-start-consent';
import { ConfirmationContainer } from '../styles';

type StartConfirmationProps = {
    consent: StartConsent;
    consentSignError?: string;
    termsLabel: React.ReactNode;
    isTermsConfirmation: boolean;
    onTermsChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    isCustomPartner?: boolean;
    isSkipIntro?: boolean;
    isLoading: boolean;
    onStart: () => void;
};

export const StartConfirmation: React.FC<StartConfirmationProps> = ({
    consent,
    consentSignError,
    termsLabel,
    isTermsConfirmation,
    onTermsChange,
    isCustomPartner,
    isSkipIntro,
    isLoading,
    onStart,
}) => {
    const { t } = useTranslation();
    const renderTermsCheckbox = (isSmall: boolean) => (
        <Checkbox
            checked={isTermsConfirmation}
            onChange={onTermsChange}
            label={
                isSmall ? (
                    <Typography tag='span' variant='small-text' color='text-main'>
                        {termsLabel}
                    </Typography>
                ) : (
                    termsLabel
                )
            }
        />
    );
    const isDisabled = consent.isBlocking || (!isSkipIntro && !isTermsConfirmation);

    return (
        <React.Fragment>
            {consent.isRequired && (
                <ConsentBlock
                    consent={consent}
                    signError={consentSignError}
                    termsCheckbox={isCustomPartner ? undefined : renderTermsCheckbox(true)}
                />
            )}
            {!isCustomPartner && !consent.isRequired && (
                <ConfirmationContainer className='confirmation-container'>
                    {renderTermsCheckbox(false)}
                </ConfirmationContainer>
            )}
            <Stack sx={{ alignItems: 'center', mb: 2 }}>
                <Button
                    variant='primary'
                    className='button'
                    onClick={onStart}
                    disabled={isDisabled}
                    size='xl'
                    loading={isLoading}
                >
                    {t('docVerificationWidget.start.btnStartVerification')}
                </Button>
            </Stack>
        </React.Fragment>
    );
};
